import { Routes, BrowserRouter as Router, Route } from "react-router-dom"
// import Route from "components/route"
import Login from "pages/login"
import Dashboard from "pages/dashboard"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import Header from "components/header"
import Search from "pages/search/search"
import NotFound from "pages/404"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { actions } from "redux/reducers"
import { RootState } from "types"
import api from "api"
// import Test from "pages/test"

function App() {
  const dispatch = useDispatch();
  const state = useSelector((state: RootState) => state);

  useEffect(() => {
    if (!state.user){
      api.user.validate().then(data => dispatch(actions.user.set(data)));
    }

    if (!state.theme){
      dispatch(actions.theme.set(localStorage.Theme));
    }
  }, [dispatch])

  useEffect(() => {  
    document.documentElement.setAttribute('data-theme', state.theme);
  }, [state.theme])

  return (
    <Router>
      <Header />
      <Routes>
        {/* APP */}
        {/* <Route path="/" exact showHeader={false} validateToken={false}> */}
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/search" element={<Search />} />
        {/* FALLBACK */}
        <Route element={<NotFound />} />
      </Routes>
      <ToastContainer hideProgressBar={true} newestOnTop={true} />
    </Router>
  )
}

export default App
